import type { ReactNode } from 'react'
import { useMe } from '../../hooks/useMe'
import { getToken } from '../../lib/auth'

export default function StaffOnly({ children }: { children: ReactNode }) {
  const authed = Boolean(getToken())
  const { me, loading } = useMe(authed)

  if (!authed) return <div className="rounded-xl border border-white/10 p-4 text-white/70">Not found</div>
  if (loading) return <div className="rounded-xl border border-white/10 p-4 text-white/70">Loading...</div>
  if (!me?.is_staff) return <div className="rounded-xl border border-white/10 p-4 text-white/70">Not found</div>
  return <>{children}</>
}
